module.exports = __webpack_public_path__ + "img/CPE-LC116.86acd917.jpg";